import { render, staticRenderFns } from "./GeographiesOptions.vue?vue&type=template&id=fee416bc&scoped=true"
import script from "./GeographiesOptions.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeographiesOptions.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GeographiesOptions.vue?vue&type=style&index=0&id=fee416bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee416bc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSurveyQuestion: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/Question.vue').default,IxTreeselectGeography: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/treeselect/Geography.vue').default})
